import React, { FC, useCallback, useState } from 'react';
import ImportGridModal from './ImportGridModal';

interface OWFlatfileButtonProps {
	type: string;
	fields: any[];
	onDataLoad: (result: { validData: any[] }) => Promise<any>;
	recordHook?: (record: any) => any;
	onCancel?: () => void;
	renderElement: (openPortal: () => void) => React.ReactNode;
	validateRecordsOnSubmit?: (data: any[]) => string | undefined | null | false;
	// When provided, the import modal opens on a 'sample' step that surfaces
	// the download-sample link alongside the upload + manual-entry choices —
	// no separate pre-modal. Without it, the modal opens directly on the
	// upload step.
	onDownloadSample?: () => void;
	sampleModalTitle?: string;
	sampleModalText?: string;
	sampleButtonText?: string;
	// When true, the sample step renders the destructive-upload warning the
	// legacy `UploadWithSampleModal` showed when `showWarningMessage` was set.
	showWarningMessage?: boolean;
	entityName?: string;
}

const OWFlatfileButton: FC<OWFlatfileButtonProps> = ({
	type,
	fields,
	onDataLoad,
	recordHook,
	onCancel,
	renderElement,
	validateRecordsOnSubmit,
	onDownloadSample,
	sampleModalTitle,
	sampleModalText,
	sampleButtonText,
	showWarningMessage,
	entityName,
}) => {
	const [importModalVisible, setImportModalVisible] = useState(false);

	const openPortal = useCallback(() => {
		setImportModalVisible(true);
	}, []);

	const handleImportCancel = useCallback(() => {
		setImportModalVisible(false);
		if (onCancel) onCancel();
	}, [onCancel]);

	const handleImportComplete = useCallback(() => {
		setImportModalVisible(false);
	}, []);

	return (
		<>
			{renderElement(openPortal)}
			{importModalVisible && (
				<ImportGridModal
					visible={importModalVisible}
					title={sampleModalTitle || `Import ${type}`}
					fields={fields}
					recordHook={recordHook}
					validateRecordsOnSubmit={validateRecordsOnSubmit}
					onDataLoad={onDataLoad}
					onCancel={handleImportCancel}
					onComplete={handleImportComplete}
					onDownloadSample={onDownloadSample}
					sampleModalText={sampleModalText}
					sampleButtonText={sampleButtonText}
					showWarningMessage={showWarningMessage}
					entityName={entityName}
				/>
			)}
		</>
	);
};

export default OWFlatfileButton;
